__turbopack_context__.v({
  "disabled": "dpe-module__HEQeSW__disabled",
  "label": "dpe-module__HEQeSW__label",
  "secondary": "dpe-module__HEQeSW__secondary",
});
